import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';

export const selectAllTemplatesData = (state: RootState) => state.template;

export const allTemplatesSelector = createSelector(
  selectAllTemplatesData, (state) => state,
);
